import { Button, Clickable, H1, List, Modal, P } from '@ahmdigital/ui';
import { tagmanager as TagManager } from '@ahmdigital/analytics';
import { useEffect } from 'react';

import constants from '../../ahm-constants';
import styles from './styles.module.sass';

type RedirectExistingMemberModalProps = {
  isOpen: boolean;
  toggleModal: () => void;
};

const MODAL_HEADER_ID = 'redirect-existing-member-modal-title' as const;
export const VIEW_ANALYTICS_EVENT = 'view_existing_member_redirect' as const;

const RedirectExistingMemberModal = ({ isOpen, toggleModal }: RedirectExistingMemberModalProps) => {
  useEffect(() => {
    if (isOpen) {
      TagManager.submit(VIEW_ANALYTICS_EVENT);
    }
  }, [isOpen]);

  return (
    <Modal className={styles.modal} ariaLabelledBy={MODAL_HEADER_ID} isOpen={isOpen} toggleModal={toggleModal}>
      <div className={styles.modalContent}>
        <div className={styles.titleAndDescription}>
          <H1 looksLike="h3" id={MODAL_HEADER_ID}>
            Are you an existing member?
          </H1>
          <P className={styles.noBottomMargin}>Log in to your account to … </P>
          <List isOrdered={false} variant="inside">
            <li>Compare your current cover with other options</li>
            <li>Switch coverage if your needs have changed</li>
          </List>
        </div>

        <div className={styles.loginAndNoThanksButtons}>
          <Button variant="wide" to={constants.URLS.MEMBERS.CHANGE_YOUR_COVER}>
            Log in
          </Button>
          <Clickable onClick={toggleModal}>No thanks</Clickable>
        </div>
      </div>
    </Modal>
  );
};

export default RedirectExistingMemberModal;
